.wrapper {
  display: flex;
  width: fit-content;
  pointer-events: auto;
  max-width: 100%;
}

.leftSection {
  border: 1px solid var(--paletteNeutral0);
  color: var(--paletteBlue0);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: var(--spacingMd);
}

.rightSection {
  background-color: var(--paletteWhite0);
  color: var(--paletteBlue0);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid var(--paletteNeutral0);
  border-left: 0;
  padding: 0 var(--spacingLg) 0 var(--spacingMd);
  min-width: auto;
}

.secondary {
  .leftSection,
  .rightSection {
    border-color: var(--paletteBlue0);
  }
}

.selected {
  svg {
    fill: var(--paletteWhite0);
  }

  .leftSection {
    background: var(--paletteBlue0);
    color: var(--paletteWhite0);
    border-color: var(--paletteBlue0);
  }

  .rightSection {
    border-color: var(--paletteBlue0);
  }
}

.faded {
  .leftSection {
    background: var(--paletteNeutral0);
    border: var(--paletteNeutral0);
  }
}
